import axios from "axios";
import {useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ResearcherLikeCommentActions from "./ResearcherLikeCommentActions";
import SendInterestModal from "./SendInterestModal";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const ResearcherPostDetails = () => {
    const navigate = useNavigate()
    const { id } = useParams();
  const [searchParams] = useSearchParams();
  const research_type = searchParams.get("research_type");
  const type = searchParams.get("type");
  const [pubExpanded, setPubExpanded] = useState(false);
  const [post, setPost] = useState(null);
     const [open,setOpen] = useState(false)
      const handleClose = () => {
    navigate('/marketplace/independent_researcher');
  };

  useEffect(()=>{
      const fetchPostDetails = async () => {
          try {
             const response = await axios.get(`${BASE_URL}/marketplace/researcher/feed/${id}?research_type=${research_type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      });
             console.log("Post details:", response.data);
             setPost(response.data);
          } catch (error) {
              console.error("Error fetching post details:", error);
          }
        }
        fetchPostDetails();
  },[research_type, type])
  return   <div className="bg-[#F9F7F4] flex items-center justify-center overflow-hidden">
    <div className="w-full h-full sm:w-screen sm:h-screen bg-[#F9F7F4] relative flex flex-col sm:flex">
   <button
            onClick={handleClose}
            className="absolute top-[1px] left-4 w-10 h-10 flex items-center justify-center bg-[#e8f0f7] text-[#0f6abf] rounded-full  z-10"
          >
            ✕
          </button>
            <div className="flex flex-col sm:flex-row w-full h-full">
                {/* first part */}
                <div className="w-full h-[60vh] sm:h-full sm:w-9/12 p-2 overflow-hidden flex items-center justify-center bg-[#F9F7F4]">
              <div className="w-full mt-12 md:mt-0 md:w-[90%] h-full   rounded-lg overflow-hidden">
               
                 <div className="flex justify-between">
                  <div className="text-lg text-gray-900 mb-2 mt-2 font-bold" >
                  {post?.name}  
                </div>
              {
  (research_type === 'opportunity' || research_type === 'lab_opportunity') && (
    <button
      onClick={() => setOpen(true)}
      className="mt-4 px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-full hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
    >
      Send Interest
    </button>
  )
}
                </div>
                {
                    research_type === 'opportunity' ||  research_type === 'lab_opportunity' ?   <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {post?.collaboration}
    </span>
    
    {/* <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.topic_of_interest}
    </span> */}
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {post?.visibility}
    </span>
  </div> : <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.field_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {post?.area_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.topic_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.research_type === 'theoreticalidea' && "Idea"}
      {post?.research_type === 'prototype' && "PoC"}
      {post?.research_type === 'labexperiment' && "Lab-ready"}
      {post?.research_type === 'industrialapplication' && "Industry Challenge"}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {post?.visibility}
    </span>
  </div>
                }
                       
   <div className="w-full h-full rounded-[10px] mt-4 cursor-pointer" >
                      {/* Media Preview */}
              {post?.publication_type === "image" && (
                <img
                  src={post?.file}
                  alt={post?.name}
                  className="w-full h-full rounded-[10px] object-cover"
                />
              )}
              {post?.publication_type === "pdf" && (
                <iframe
                  src={`${post?.file}#toolbar=0`}
                  title={post?.name}
                  className="w-full h-full rounded-[10px]"
                />
              )}
              {(post?.publication_type === "doc" || post?.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    post?.file
                  )}&embedded=true`}
                  title={post?.name}
                  className="w-full h-full rounded-[10px]"
                />
              )}
              {post?.publication_type === "video" && (
                <video
                  src={post?.file}
                  controls
                  className="w-full h-full rounded-[10px] object-cover"
                />
              )}
              {post?.publication_type === "audio" && (
                <div className="w-full h-full rounded-[10px] flex items-center justify-center bg-gray-100">
                  <audio src={post?.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
              </div>
            </div>
            {/* second part */}
               <div className="relative w-full sm:w-3/12 h-[40vh] sm:h-full flex flex-col bg-white overflow-hidden">
              <div className="flex-1 overflow-y-auto p-3 sm:pt-6 sm:px-4">
                {/* User Info - Mobile optimized */}
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <img
                      src={post?.profile_data?.profile_picture}
                      alt="User"
                      className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-xl object-cover border-2 border-white shadow-sm"
                    //  onClick={()=>navigate(`${currentUserId === post?.userId ? "/profile-view" : `/user-profile/${post?.user_profile?.id}`}`)}
                    />
                    <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                  </div>
                  <div className="flex flex-col">
                    <span className="font-semibold text-gray-900 text-sm sm:text-base">
                      {post?.profile_data?.name}
                    </span>
                  </div>
                </div>
                {
                  post?.description &&
                    <div className="mt-3 sm:mt-4 text-base sm:text-lg  text-gray-900 mb-2 break-words">
                      {pubExpanded || (post?.description?.length || 0) <= 120
                        ? post?.description
                        : post?.description.slice(0, 120) + "..."}

                      {(post?.description?.length || 0) > 120 && (
                        <span
                          onClick={() => setPubExpanded(!pubExpanded)}
                          className="text-blue-600 cursor-pointer ml-1 font-medium"
                        >
                          {pubExpanded ? " Read less" : " Read more"}
                        </span>
                      )}
                    </div>
               
                }
                {/* {post?.reference && (
                  <div className="my-4 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                    <div className="flex items-center gap-2 mb-3">
                      <ExternalLink size={18} className="text-blue-500" />
                      <h3 className="text-lg font-semibold text-gray-800">Reference Post</h3>
                    </div>
                    <a
                      href={post?.reference}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
                    >
                      <Link size={16} className="text-gray-400 group-hover:text-blue-500" />
                      <span className="text-blue-600 hover:text-blue-700 font-medium break-all">
                        {post?.reference}
                      </span>
                    </a>
                  </div>
                )} */}

                {/* {currentUserId && ( */}
                  <div className="border-t pt-4">
                    <ResearcherLikeCommentActions
                          postId={post?.id}
                      type={post?.research_type}
                      is_Liked={post?.is_liked}
                      likeCount={post?.like_count}
                      isOpen={true}
                      postOwnerId={post?.profile_data?.id}
                    />
                  </div>
                {/* )} */}
              </div>
            </div>
            </div>
    </div>
      <SendInterestModal isOpen={open} onClose={() => setOpen(false)} postOwnerId={post?.profile_data?.user} />
    </div>;
};

export default ResearcherPostDetails;